import * as React from 'react';

import ClockArrow16 from './ClockArrow16';

export const clockArrow16 = () => <ClockArrow16 />;

export default {
    title: 'Icon|Line|ClockArrow16',
    component: ClockArrow16,
    parameters: {
        notes: "`import ClockArrow16 from 'box-ui-elements/es/icon/line/ClockArrow16';`",
    },
};
